import { WindowState, breakpointsNumber } from "../../theme";
import { IWindowSize } from "../types/input.types";

export const getWindowState = (windowSize: IWindowSize): WindowState => {
  if(windowSize.width <= breakpointsNumber.xs) return "xs";
  if(windowSize.width <= breakpointsNumber.sm) return "sm";
  if(windowSize.width <= breakpointsNumber.md) return "md";
  if(windowSize.width <= breakpointsNumber.lg) return "lg";
  return "xl";
}